import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { AbsoluiteImage, Image } from "../../../../Styles/style";
import heading from "../../../../../assets/Images/vault.png";
import tokenImage from "../../../../../assets/Images/tokenImage.png";
import Paragraph from "../../Paragraph";
import CustomButton from "../../CustomBtn";
import SectionsHeading from "../../SectionsHeading";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  /* flex-direction:column; */
  justify-content: start;
  align-items: start;
  padding: 50px 0 00px;
  column-gap: 20px;
`;
const ContinerWraper = styled(Container)`
  background: ${(props) => props.theme.bgPrimary};
  width: 100%;
  border-radius: 20px;
  padding: 10px 0 0 !important;
  margin-top: 30px;
`;
const InnerGrid = styled(Grid)`
  background: #161616;
  width: 100%;
  border-radius: 20px;
  padding: 30px;
  margin-top: 30px;
`;
const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40%;
  padding: 20px 0;
  @media (max-width: 899px) {
    width: 100%;
  }
`;
const ContractDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 35%;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 10px 20px;
  @media (max-width: 899px) {
    width: 100%;
  }
`;
const TokenomicsSection = () => {
  return (
    <Container maxWidth="xxl" id="tokenomics" sx={{p:"100px 0 !important"}}>
      <ContinerWraper>
        <GridWraper container>
          <AbsoluiteImage
            op=".1"
            l="90%"
            t="50%"
            tran="translate(-90%,-50%)"
            mw="370px"
            src={tokenImage}
          />
          <Grid item xs={12} md={6} sx={{ padding: "0 30px 20px" }}>
            <Image mw="350px" src={heading} />
            <Paragraph p="20px 0px" ta="left" fs="12px">
              Our lending platform isn't your only source of value. Try
              investing in ShiaVault's very own tokens!
            </Paragraph>
            <div style={{ display: "flex" }}>
              <CustomButton
                hbgc="transparent"
                hc="#fff"
                bgc="#fff"
                c="#000"
                b="1px solid #fff"
              >
                Buy Now
              </CustomButton>
              <CustomButton
                bgc="transparent"
                c="#fff"
                hbgc="#fff"
                hc="#000"
                b="1px solid #fff"
              >
                View Chart
              </CustomButton>
            </div>
          </Grid>
          <InnerGrid item xs={12}>
            <SectionsHeading
              ta="left"
              fs="22px"
              fs599="22px"
              color="#FC9C00 !important"
            >
              Tokenomics
            </SectionsHeading>
            <Div>
              <div>
                <SectionsHeading
                  ta="left"
                  fs="16px"
                  fs599="16px"
                  p="10px 0"
                  p599="10px 0"
                  p899="10px 0"
                >
                  Supply
                </SectionsHeading>
                <SectionsHeading ta="left" fs="32px" fs599="32px" fm="PoppinsR">
                  149M
                </SectionsHeading>
              </div>
              <div>
                <SectionsHeading
                  ta="left"
                  fs="16px"
                  fs599="16px"
                  p="10px 0"
                  p599="10px 0"
                  p899="10px 0"
                >
                  Taxes
                </SectionsHeading>
                <SectionsHeading ta="left" fs="32px" fs599="32px" fm="PoppinsR">
                  1/2
                </SectionsHeading>
              </div>
              <div>
                <SectionsHeading
                  ta="left"
                  fs="16px"
                  fs599="16px"
                  p="10px 0"
                  p599="10px 0"
                  p899="10px 0"
                >
                  Max Wallet
                </SectionsHeading>
                <SectionsHeading ta="left" fs="32px" fs599="32px" fm="PoppinsR">
                  1%
                </SectionsHeading>
              </div>
            </Div>
            <ContractDiv>
              <SectionsHeading
                ta="left"
                fs="16px"
                fs599="16px"
                p="0px 0"
                p599="0px 0"
                p899="0px 0"
              >
                CA
              </SectionsHeading>
              <SectionsHeading
                ta="left"
                fs="16px"
                fs599="16px"
                p="0px 0"
                p599="0px 0"
                p899="0px 0"
                sx={{ wordBreak: "break-all" }}
              >
                TBA
              </SectionsHeading>
            </ContractDiv>
          </InnerGrid>
        </GridWraper>
      </ContinerWraper>
    </Container>
  );
};

export default TokenomicsSection;
